import { render, staticRenderFns } from "./TeamLeader.vue?vue&type=template&id=878083da&scoped=true&"
import script from "./TeamLeader.vue?vue&type=script&lang=ts&"
export * from "./TeamLeader.vue?vue&type=script&lang=ts&"
import style0 from "./TeamLeader.vue?vue&type=style&index=0&id=878083da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878083da",
  null
  
)

export default component.exports